/*
 * Class Press
 * @constructor
 * Created by: Fer Catalano
 */

/* Constructor */
function Press() {
    if (window.location.href.split('/')[3] === "press" || window.location.href.split('/')[4] === "press") {
        window.addEventListener('load', this.init);
        jQuery(document).on('updated_wc_div', this.init);
    }
}

Press.prototype.init = function () {
    var sortbyrelevance = false;
    // Sort by relevance
    jQuery("input[name='sortbyrelevance']").change(function () {
        if (jQuery("input[name='sortbyrelevance']").is(':checked')) {
            sortbyrelevance = true;
        } else {
            sortbyrelevance = false;
        }
        if (jQuery("input[name='sortbylastmonth']").is(':checked')) {
            let date = document.querySelector('#sortbylastmonth');
            Press.prototype.filter(date.value, 'filterByMonth', sortbyrelevance);
        } else {
            // filter event
            let date = document.querySelector('#sortbydate');
            if (date.value == '') {
                Press.prototype.filter(false, 'filterByDate', sortbyrelevance);
            } else {
                Press.prototype.filter(date.value, 'filterByDate', sortbyrelevance);
            }
        }
    });
    // Sort by last month
    jQuery("input[name='sortbylastmonth']").change(function () {
        if (jQuery("input[name='sortbylastmonth']").is(':checked')) {
            let date = document.querySelector('#sortbylastmonth');
            Press.prototype.filter(date.value, 'filterByMonth', sortbyrelevance);
        } else {
            // filter event false
            Press.prototype.filter(false, 'filterByMonth', sortbyrelevance);
        }
    });
    // Sort by date
    jQuery("input[name='sortbydate']").change(function () {
        let date = document.querySelector('#sortbydate');

        if (date.value == '') {
            //remove css class
            date.classList.remove('press-filters__filled');
        } else {
            //add css class
            date.classList.add('press-filters__filled');
        }
        // filter event
        Press.prototype.filter(date.value, 'filterByDate', sortbyrelevance);
    });
};

Press.prototype.filter = function (value, type, sortbyrelevance) {
    let highlights = document.querySelector('#js-press-highlights');
    let formData = new FormData();
    formData.append('action', 'get_baketivity_press');
    formData.append('sortbyrelevance', sortbyrelevance);
    formData.append('date_value', value);
    formData.append('type', type);

    jQuery.ajax({
        cache: false,
        url: ajax.url,
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        beforeSend: function () {
            jQuery('.press-featured-in__result').show().html('<div class="grid-shop__loader"><span></span></div>');
        },
        success: function (response) {
            // hide loader and clear html
            highlights.innerHTML = '';

            // No resources
            if (response.data.html.length == 0) {
                jQuery('.press-featured-in__result').show().html('<p>No press found</p>');
                return;
            }

            // There are resources
            highlights.innerHTML = response.data.html;
        },
        complete: function () {
            jQuery('.press-featured-in__result').hide().html('');
            console.log('complete');
        },
        error: function () {
            jQuery('#js-press-highlights').hide().html('');
            jQuery('.press-featured-in__result').show().html('<p>Something went wrong</p>');
        }
    });
};

var press = new Press();